import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  // Navigation modules fetched from API (includes subModules)
  navModules: null,
  // Country dropdown options
  countryOptions: null,
  // Track if data has been fetched (prevents re-fetch on navigation)
  hasFetchedNav: false,
  hasFetchedCountryOptions: false,
}

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setNavModules: (state, action) => {
      state.navModules = action.payload
      state.hasFetchedNav = true
    },
    setCountryOptions: (state, action) => {
      state.countryOptions = action.payload
      state.hasFetchedCountryOptions = true
    },
    clearNavigation: state => {
      state.navModules = null
      state.countryOptions = null
      state.hasFetchedNav = false
      state.hasFetchedCountryOptions = false
    },
    // Call this when country changes to re-fetch nav modules
    invalidateNavModules: state => {
      state.navModules = null
      state.hasFetchedNav = false
    },
  },
})

export const {
  setNavModules,
  setCountryOptions,
  clearNavigation,
  invalidateNavModules,
} = navigationSlice.actions
export default navigationSlice.reducer
